export default __webpack_public_path__ + "static/media/menuDotBlack.56535758.svg";